import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaQuoteRight, FaStar } from "react-icons/fa"; // Import necessary React Icons

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div
      className="container-fluid testimonial pb-5"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="container pb-5">
        <div
          className="text-center mx-auto pb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "800px" }}
        >
          <h1 className="display-5 text-capitalize mb-3">
            Our Clients' <span className="text-primary">Reviews</span>
          </h1>
          <p className="mb-0">
            Here's what our satisfied customers have to say about their
            experience with Steward Cars.
          </p>
        </div>
        <Slider {...settings} className="wow fadeInUp" data-wow-delay="0.1s">
          <div className="testimonial-item">
            <div className="testimonial-quote">
              <FaQuoteRight size={30} />{" "}
              {/* Replaced fa-quote-right with React Icon */}
            </div>
            <div className="testimonial-inner p-4">
              <img
                src="img/testimonial-1.jpg"
                className="img-fluid"
                alt="Client 1"
              />
              <div className="ms-4">
                <h4>James Aoko</h4>
                <p>Business Traveler</p>
                <div className="d-flex text-primary">
                  {[...Array(4)].map((_, index) => (
                    <FaStar key={index} />
                  ))}
                  <FaStar className="text-body" />{" "}
                  {/* One star with different color */}
                </div>
              </div>
            </div>
            <div className="border-top rounded-bottom p-4">
              <p className="mb-0">
                "Steward Cars provided an exceptional rental experience! The car
                was in excellent condition, and the service was top-notch."
              </p>
            </div>
          </div>
          <div className="testimonial-item">
            <div className="testimonial-quote">
              <FaQuoteRight size={30} />
            </div>
            <div className="testimonial-inner p-4">
              <img
                src="img/testimonial-2.jpg"
                className="img-fluid"
                alt="Client 2"
              />
              <div className="ms-4">
                <h4>Jane Wangeshi</h4>
                <p>Accountant</p>
                <div className="d-flex text-primary">
                  {[...Array(4)].map((_, index) => (
                    <FaStar key={index} />
                  ))}
                  <FaStar className="text-body" />
                </div>
              </div>
            </div>
            <div className="border-top rounded-bottom p-4">
              <p className="mb-0">
                "I had a fantastic experience renting a car from Steward Cars.
                The booking process was easy, and the staff was very helpful."
              </p>
            </div>
          </div>
          <div className="testimonial-item">
            <div className="testimonial-quote">
              <FaQuoteRight size={30} />
            </div>
            <div className="testimonial-inner p-4">
              <img
                src="img/testimonial-3.jpg"
                className="img-fluid"
                alt="Client 3"
              />
              <div className="ms-4">
                <h4>Alfred Waweru</h4>
                <p>Business Man</p>
                <div className="d-flex text-primary">
                  {[...Array(4)].map((_, index) => (
                    <FaStar key={index} />
                  ))}
                  <FaStar className="text-body" />
                </div>
              </div>
            </div>
            <div className="border-top rounded-bottom p-4">
              <p className="mb-0">
                "Renting from Steward Cars made our family trip unforgettable.
                The car was spacious and perfect for our needs!"
              </p>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Testimonial;
